// Tools to measure how well the estimated transformations fit the data.
//

exports.mse = require('./mse')
exports.residuals = require('./residuals')
exports.rss = require('./rss')
